import * as v from 'valibot';
import { SaveV6Schema, type SaveV6, CURRENT_SCHEMA_MINOR } from './schema-v6';
import { logger } from '../logger/Logger';

export interface SaveCodec {
  encode(snap: SaveV6): string;
  decode(raw: unknown): SaveV6 | null;
  currentVersion(): { major: 6; minor: number };
}

class SaveCodecImpl implements SaveCodec {
  encode(snap: SaveV6): string {
    return JSON.stringify(snap);
  }

  decode(raw: unknown): SaveV6 | null {
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      const result = v.safeParse(SaveV6Schema, parsed);
      if (!result.success) {
        logger.warn('save-codec.invalid', { issuesCount: result.issues.length });
        return null;
      }
      return result.output;
    } catch (err) {
      logger.warn('save-codec.parse-failed', { err: String(err) });
      return null;
    }
  }

  currentVersion(): { major: 6; minor: number } {
    return { major: 6, minor: CURRENT_SCHEMA_MINOR };
  }
}

export const saveCodec: SaveCodec = new SaveCodecImpl();
